<template>
  <div
    class="
      fixed
      bottom-0
      md:bottom-auto md:top-1/2 md:right-0 md:-translate-y-1/2
      z-30
      flex
      md:flex-col md:w-[90px]
      items-baseline
      md:items-center
      justify-between
      md:justify-center
      w-full
      px-4
      py-2
      md:p-0
      bg-white
      md:bg-transparent md:divide-y md:divide-white md:overflow-hidden
      widget
      md:rounded-l-3xl
    "
    :style="{
      boxShadow: $screen.md
        ? '0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)'
        : '0 -1px 6px -1px rgb(0 0 0 / 10%)',
    }"
  >
    <div
      v-for="item in menus"
      :key="item.name"
      :class="`${!widgetShown && 'md:hidden'}`"
      class="md:bg-monza md:w-full md:px-0.5 md:h-auto"
    >
      <a
        :href="item.url"
        class="
          flex flex-col
          items-center
          justify-center
          text-center
          md:h-[80px]
        "
      >
        <img
          :src="item.img"
          :alt="item.name"
          class="h-[22px] mb-0.5 md:h-[34px] md:w-[34px]"
          height="22"
        />
        <div
          class="
            text-gray-800
            md:text-white
            text-xs
            md:text-[10px]
            leading-[18px]
            font-ubuntu-bold
            md:font-ubuntu-regular md:font-bold md:leading-tight
          "
        >
          {{ item.name }}
        </div>
      </a>
    </div>
    <div
      class="hidden px-0.5 bg-white text-center w-full h-12 cursor-pointer"
      :class="`${widgetShown ? 'md:block' : 'md:hidden'}`"
      @click="toggleWidget"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-9 w-9 text-monza mx-auto"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div
      class="
        hidden
        md:block
        w-full
        h-[80px]
        bg-white
        rounded-l-3xl
        cursor-pointer
      "
      :class="`${widgetShown ? 'md:hidden' : 'md:block'}`"
      @click="toggleWidget"
    >
      <div
        class="flex flex-col items-center justify-center text-center h-[80px]"
      >
        <img
          src="../assets/images/widget-icon/icon-widget.png"
          alt="Daihatsu Indonesia"
          class="mb-0.5 h-7"
          height="28"
          width="28"
        />
        <div
          class="
            hidden
            md:block
            text-monza text-xs
            break-words
            w-14
            font-ubuntu-regular font-bold
            leading-tight
          "
        >
          Shopping Tools
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VueScreen from 'vue-screen'

Vue.use(VueScreen)

export default {
  name: 'Widget',
  data() {
    return {
      items: [
        {
          name: 'Penawaran',
          img: 'https://cdn.statically.io/img/ik.imagekit.io/neo/icon_penawaran_active_tXPbCN4rK.png',
          url: 'https://daihatsu.co.id/request-quotes/',
        },
        {
          name: 'Booking Service',
          img: 'https://cdn.statically.io/img/ik.imagekit.io/neo/icon_booking_normal_coysJ3hGNQks.png',
          url: 'https://daihatsu.co.id/ownership/booking-service/',
        },
        {
          name: 'Simulasi Kredit',
          img: 'https://cdn.statically.io/img/ik.imagekit.io/neo/icon_simulasi_normal_kzAVkSwBGzEp.png',
          url: 'https://daihatsu.co.id/simulasi-kredit/',
        },
        {
          name: 'Pricelist',
          img: 'https://cdn.statically.io/img/ik.imagekit.io/neo/icon_pricelist_normal_VOnKolVMq.png',
          url: 'https://daihatsu.co.id/price-list/',
        },
      ],
      widgets: [
        {
          img: require('../assets/images/widget-icon/icon-penawaran.png'),
          srchover: require('../assets/images/widget-icon/icon-penawaran-red.png'),
          url: 'https://daihatsu.co.id/request-quotes/',
          name: 'Dapatkan Penawaran',
          alt_image: 'Daihatsu Indonesia',
        },
        {
          img: require('../assets/images/widget-icon/icon-booking.png'),
          srchover: require('../assets/images/widget-icon/icon-booking-red.png'),
          url: 'https://daihatsu.co.id/ownership/booking-service',
          name: 'Booking Service',
          alt_image: 'Booking Service',
        },
        {
          img: require('../assets/images/widget-icon/icon-kredit.png'),
          srchover: require('../assets/images/widget-icon/icon-kredit-red.png'),
          url: 'https://daihatsu.co.id/simulasi-kredit/',
          name: 'Simulasi Kredit',
          alt_image: 'Simulasi Kredit',
        },
        {
          img: require('../assets/images/widget-icon/icon-pricelist.png'),
          srchover: require('../assets/images/widget-icon/icon-pricelist-red.png'),
          url: 'https://daihatsu.co.id/price-list/',
          name: 'Price List',
          alt_image: 'Rupiah',
        },
      ],
      widgetShown: true,
    }
  },
  computed: {
    menus() {
      if (this.$screen.md) {
        return this.widgets
      }

      return this.items
    },
  },
  methods: {
    toggleWidget() {
      this.widgetShown = !this.widgetShown
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500&display=swap');
</style>

<style lang="scss" scoped>
@import url('../assets/scss/tailwind.scss');

.navbar {
  font-family: 'Ubuntu';
}
</style>
